import type { TranslationKey } from "../locales";
import type { Nullable, WebfleetOrderType } from "../types";

/**
 * This function returns the translation key for a given Webfleet order type.
 * @param orderType
 * @returns
 */
export function getWebfleetOrderTypeTranslationKey(
	orderType: Nullable<WebfleetOrderType>,
): TranslationKey {
	switch (orderType) {
		case 1:
			return "vehicles.order_type.service";
		case 2:
			return "vehicles.order_type.pickup";
		case 3:
			return "vehicles.order_type.delivery";
		default:
			return "vehicles.order_type.unknown";
	}
}
